import { render, staticRenderFns } from "./PagesSumRegionView.vue?vue&type=template&id=466c6296&scoped=true"
import script from "./PagesSumRegionView.vue?vue&type=script&lang=js"
export * from "./PagesSumRegionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466c6296",
  null
  
)

export default component.exports